import type { Action, PayloadAction } from '@reduxjs/toolkit';
import { all, delay, put, race, take, takeEvery } from 'typed-redux-saga';

import { addNotification, hideNotification, notify, removeNotification } from './slice';
import type { NotificationItem } from './types';

function* notifySaga({ payload: notification }: PayloadAction<NotificationItem>) {
    yield* put(addNotification(notification));
    if (notification.timeout) {
        const { timeout } = yield* race({
            timeout: delay(notification.timeout as number),
            sameNotify: take((action: Action) => {
                return notify.match(action) && action.payload.id === notification.id;
            }),
        });

        if (timeout) {
            yield* put(hideNotification(notification.id));
        }
    }
}

function* hideNotificationSaga({ payload: notificationId }: PayloadAction<string>) {
    yield* put(removeNotification(notificationId));
}

export function* psNotificationsSaga() {
    yield* all([takeEvery(notify.type, notifySaga), takeEvery(hideNotification.type, hideNotificationSaga)]);
}
